export interface TimeLimit {
  day: number;
  from: string;
  to: string;
  position?: string;
}

export interface ShippingRate {
  id: number;
  vendorId: number;
  enabled: boolean;
  title: string;
  description?: string;
  minPrice: number;
  shippingZone?: Record<string, unknown> | null;
  totalFrom?: number;
  totalTo?: number;
  weightFrom?: number;
  weightTo?: number;
  volumeFrom?: number;
  volumeTo?: number;
  maxWeight?: number;
  maxVolume?: number;
  priceCalculation: string;
  orderStart?: number;
  orderStep?: number;
  orderValue?: number;
  distanceStart?: number;
  distanceStep?: number;
  distanceValue?: number;
  weightStart?: number;
  weightStep?: number;
  weightValue?: number;
  volumeStart?: number;
  volumeStep?: number;
  volumeValue?: number;
  minHoursDisplay?: number;
  maxDaysToDisplay?: number;
  maxSimultaneousToDisplay?: number;
  timeLimits?: TimeLimit[];
  shippingTypeIds: number[];
}

export interface DeliveryConfig {
  timeLimits: TimeLimit[];
  weekOffdays: number[];
}

export const PRICE_CALCULATIONS = ['MIN', 'MAX', 'SUM'] as const;
export const WEEKDAY_LABELS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

export interface ShippingTypeOption {
  id: number;
  label: string;
}

export interface ExtraField {
  label: string;
  type: '1' | '2' | string;
  options?: string;
}

export interface StorePickupConfig {
  enabled: boolean;
  title?: string;
  description?: string;
  minHoursDisplay?: number;
  maxDaysToDisplay?: number;
  maxSimultaneousToDisplay?: number;
  timeLimits: TimeLimit[];
  extraFields: ExtraField[];
}

export interface ZippinConfig {
  enabled: boolean;
  title?: string;
  description?: string;
  shippingTypeIds: number[];
  apiKey?: string;
  apiSecret?: string;
  accountId?: string;
  originId?: string;
  addDeliveryTimeDays?: number;
  extraFields: ExtraField[];
}
